/* eslint-disable jsx-a11y/anchor-is-valid */

import React from "react";
import ic_account_balance_big_circle from "../../assets/images/pictures/icon/ic_account_balance_big_circle-64px.svg";
import ic_signal_cellular_big_circle from "../../assets/images/pictures/icon/ic_signal_cellular_big_circle-64px.svg";
import ic_2_persons_big_circle_1 from "../../assets/images/pictures/icon/ic_peoples_outline_big_circle-64px.svg";
import ic_shopping_cart_big_circle from "../../assets/images/pictures/icon/ic-outline-shopping_cart_big_circle-64px.svg";
import ic_2_persons_big_circle_2 from "../../assets/images/pictures/icon/ic_outline-peoples_big_circle-64px.svg";
import ic_trending_big_circle from "../../assets/images/pictures/icon/ic_baseline-trending_up_big_circle-64px.svg";
import ic_hammer_big_circle from "../../assets/images/pictures/icon/ic_baseline-hammer_big_circle-64px.svg";
import ic_chat_big_circle from "../../assets/images/pictures/icon/ic_outline-question_answer_big_circle-64px.svg";
import dogo from "../../assets/images/pictures/customer-footer.png";
// import ic_retangle from "../../assets/images/pictures/icon/ic_rectangle.svg"
import { motion } from "framer-motion";
import routeVariants from "../../assets/animates/routeVariants";
import { useTranslation } from "react-i18next";
import NavbarBottom from "./../global/NavbarBottom";
import Footer from "./../global/Footer";
import ic_retangle from "../../assets/images/pictures/icon/ic_retangle_blue.svg";
import work from "../../assets/images/logos/case/workis.png";
import Work from "../../assets/images/logos/case/workis.svg";
import rent from "../../assets/images/logos/case/rent.png";
import Rent from "../../assets/images/logos/case/rent.svg";
import Lock from "../../assets/images/logos/case/lock.svg";
import logo_gopaperless from "../../assets/images/logos/paperless/gopaperless-logo-124x50-fit.png";
import { Link } from "react-router-dom";

const CaseStudiesContent = () => {
  const { t } = useTranslation();

  return (
    <motion.div
      variants={routeVariants}
      initial="initial"
      animate="final"
      id="content"
      className="fs-navigation-overlay-content fs-navigation-overlay-left-content fs-navigation__0 no-transform"
    >
      <div className="container px-md-0">
        <div className="row pt-30">
          <div className="col-md-12 text-center">
            <div className="col-sm-10 col-sm-offset-1 mb-30">
              <h2 className="font-weight-bold">
                {t(
                  "case-studies-page.case-studies-page-content.content-1.heading"
                )}
              </h2>
              <p className="mb-25 mt-25">
                {t(
                  "case-studies-page.case-studies-page-content.content-1.description"
                )}
              </p>
            </div>
            <div className="row">
              <div className="col-sm-6">
                <h3 className="departments-heading">
                  {t(
                    "case-studies-page.case-studies-page-content.content-2.small-heading-1"
                  )}
                </h3>
                <ul className="departments-list">
                  <li>
                    <Link to="/case-studies/financial">
                      <img
                        src={ic_account_balance_big_circle}
                        className="icon"
                        alt=""
                        data-no-retina=""
                      />
                      <span>
                        {t(
                          "case-studies-page.case-studies-page-content.content-2.small-description-1"
                        )}
                      </span>
                      <svg
                        className="dep-arrow"
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                      >
                        <path d="M0 0h24v24H0z" fill="none"></path>
                        <path d="M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8z"></path>
                      </svg>
                    </Link>
                  </li>
                  <li>
                    <Link to="/case-studies/telco">
                      <img
                        src={ic_signal_cellular_big_circle}
                        className="icon"
                        alt=""
                        data-no-retina=""
                      />
                      <span>
                        {t(
                          "case-studies-page.case-studies-page-content.content-2.small-description-2"
                        )}
                      </span>
                      <svg
                        className="dep-arrow"
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                      >
                        <path d="M0 0h24v24H0z" fill="none"></path>
                        <path d="M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8z"></path>
                      </svg>
                    </Link>
                  </li>
                  <li>
                    <Link to="/case-studies/public">
                      <img
                        src={ic_2_persons_big_circle_1}
                        className="icon"
                        alt=""
                        data-no-retina=""
                      />
                      <span>
                        {t(
                          "case-studies-page.case-studies-page-content.content-2.small-description-3"
                        )}
                      </span>
                      <svg
                        className="dep-arrow"
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                      >
                        <path d="M0 0h24v24H0z" fill="none"></path>
                        <path d="M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8z"></path>
                      </svg>
                    </Link>
                  </li>
                </ul>
              </div>
              <div className="col-sm-6">
                <h3 className="departments-heading">
                  {t(
                    "case-studies-page.case-studies-page-content.content-2.small-heading-2"
                  )}
                </h3>
                <ul className="departments-list">
                  <li>
                    <Link to="/case-studies/procurement">
                      <img
                        src={ic_shopping_cart_big_circle}
                        className="icon"
                        alt=""
                        data-no-retina=""
                      />
                      <span>
                        {t(
                          "case-studies-page.case-studies-page-content.content-2.small-description-4"
                        )}
                      </span>
                      <svg
                        className="dep-arrow"
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                      >
                        <path d="M0 0h24v24H0z" fill="none"></path>
                        <path d="M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8z"></path>
                      </svg>
                    </Link>
                  </li>
                  <li>
                    <Link to="/case-studies/hr">
                      <img
                        src={ic_2_persons_big_circle_2}
                        className="icon"
                        alt=""
                        data-no-retina=""
                      />
                      <span>
                        {t(
                          "case-studies-page.case-studies-page-content.content-2.small-description-5"
                        )}
                      </span>
                      <svg
                        className="dep-arrow"
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                      >
                        <path d="M0 0h24v24H0z" fill="none"></path>
                        <path d="M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8z"></path>
                      </svg>
                    </Link>
                  </li>
                  <li>
                    <Link to="/case-studies/sales">
                      <img
                        src={ic_trending_big_circle}
                        className="icon"
                        alt=""
                        data-no-retina=""
                      />
                      <span>
                        {t(
                          "case-studies-page.case-studies-page-content.content-2.small-description-6"
                        )}
                      </span>
                      <svg
                        className="dep-arrow"
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                      >
                        <path d="M0 0h24v24H0z" fill="none"></path>
                        <path d="M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8z"></path>
                      </svg>
                    </Link>
                  </li>
                  <li>
                    <Link to="/case-studies/legal">
                      <img
                        src={ic_hammer_big_circle}
                        className="icon"
                        alt=""
                        data-no-retina=""
                      />
                      <span>
                        {t(
                          "case-studies-page.case-studies-page-content.content-2.small-description-7"
                        )}
                      </span>
                      <svg
                        className="dep-arrow"
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                      >
                        <path d="M0 0h24v24H0z" fill="none"></path>
                        <path d="M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8z"></path>
                      </svg>
                    </Link>
                  </li>
                  <li>
                    <Link to="/case-studies/cs">
                      <img
                        src={ic_chat_big_circle}
                        className="icon"
                        alt=""
                        data-no-retina=""
                      />
                      <span>
                        {t(
                          "case-studies-page.case-studies-page-content.content-2.small-description-8"
                        )}
                      </span>
                      <svg
                        className="dep-arrow"
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                      >
                        <path d="M0 0h24v24H0z" fill="none"></path>
                        <path d="M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8z"></path>
                      </svg>
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="container customers mb-50">
        <div className="row">
          <div className="col-sm-12 text-center">
            <img src={ic_retangle} data-no-retina="" alt="" />
            <h1>{t("casestudy.note1")}</h1>
          </div>
          <div className="col-sm-6 col-md-4 col-lg-3">
            <a href="javascript:;" className="card">
              <img
                className="card__bg img-responsive"
                src={work}
                alt="Workis"
                data-no-retina=""
              />
              <img
                className="card__logo"
                src={Work}
                alt="Workis"
                data-no-retina=""
              />
              <p className="card__info">{t("casestudy.note2")}</p>
            </a>
          </div>
          <div className="col-sm-6 col-md-4 col-lg-3">
            <a href="javascript:;" className="card">
              <img
                className="card__bg img-responsive"
                src={rent}
                alt="Rent Vilnius"
                data-no-retina=""
              />
              <img
                className="card__logo"
                src={Rent}
                alt="Rent Vilnius"
                data-no-retina=""
              />
              <p className="card__info">{t("casestudy.note3")} </p>
            </a>
          </div>
             <div className="col-sm-6 col-md-4 col-lg-3">
            <a href="javascript:;" className="card">
              <img
                className="card__bg img-responsive"
                src={Lock}
                alt="GPL"
                data-no-retina=""
              />
              <img
                className="card__logo"
                src={logo_gopaperless}
                alt="GPL"
                data-no-retina=""
              />
              <p className="card__info">{t("casestudy.note4")} </p>
            </a>
          </div>
        </div>
      </div>
      <div className="container-fluid container-fluid--background">
        <div className="container features-page__container features-page__container--footer px-md-0">
          <div className="row">
            <div className="col-sm-6">
              <h2 className="font-weight-bold mx-auto">
                {t(
                  "case-studies-page.case-studies-page-content.content-3.heading"
                )}
              </h2>
              <p className="mt-25 mb-25">
                {t(
                  "case-studies-page.case-studies-page-content.content-3.description"
                )}
              </p>
              <Link to="/solutions" className="btn-secondary">
                {t(
                  "case-studies-page.case-studies-page-content.content-3.button-take-a-look"
                )}
              </Link>
            </div>
            <div className="col-sm-6">
              <img
                className="img-responsive"
                width="350px"
                src={dogo}
                alt="GoPaperless"
              />
            </div>
          </div>
        </div>
      </div>
      <Footer />
      <NavbarBottom />
    </motion.div>
  );
};

export default CaseStudiesContent;
